import { render, staticRenderFns } from "./customNumber.vue?vue&type=template&id=e9fd8b04&scoped=true"
import script from "./customNumber.vue?vue&type=script&lang=js"
export * from "./customNumber.vue?vue&type=script&lang=js"
import style0 from "./customNumber.vue?vue&type=style&index=0&id=e9fd8b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fd8b04",
  null
  
)

export default component.exports